let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hoLvO"), load("aZinD"), load("hvHZS")]).then(() => parcelRequire('5QLLH'));